<template>
  <section class="apply_mess">
    <template v-if="showApplyInput">
      <h3>填写申请信息</h3>
      <section class="mess_list">
        <section class="mess_list_item">
          <p class="list_item_left">
            申请人
            <span>*</span>
          </p>
          <input
            class="list_item_right"
            type="text"
            v-model="userName"
            @input="nameInputFun"
            placeholder="请输入真实姓名"
          />
        </section>
        <section class="mess_list_item">
          <p class="list_item_left">
            生效开始
            <span>*</span>
          </p>
          <p
            @click="selectTime(1)"
            :class="['list_item_right','list_item_right_p',startTime?'':'placeholder']"
          >{{startTime?startTime:'请选择开始日期'}}</p>
          <img src="../../../assets/images/icon_indicator_next.png" />
        </section>
        <section class="mess_list_item">
          <p class="list_item_left">
            生效结束
            <span>*</span>
          </p>
          <p
            @click="selectTime(2)"
            :class="['list_item_right','list_item_right_p','last',endTime?'':'placeholder']"
          >{{endTime?endTime:'请选择结束日期'}}</p>
          <img src="../../../assets/images/icon_indicator_next.png" />
        </section>
      </section>
      <yd-datetime
        style="display:none;"
        ref="datetime_date"
        @input="dateChange"
        type="date"
        v-model="date"
        :startDate="curDate"
        :endDate="maxDate"
      ></yd-datetime>
      <yd-datetime
        style="display:none;"
        ref="datetime_month"
        @input="dateChange"
        type="month"
        v-model="date_m"
        :startDate="curDate"
        :endDate="maxDate"
      ></yd-datetime>
    </template>
    <template v-else>
      <section class="end_time">
        <img src="../../../assets/images/warning.jpg" />
        <p>该月卡优惠将于{{maxEndDay|formatTime(181)}}结束</p>
      </section>
    </template>
  </section>
</template>

<script>
import util from '../../../utils/util';
export default {
  data() {
    return {
      date: '',
      date_m: '',
      startDate: null,
      timeT: 1,//区分点击哪个选择时间控件
      startTime: '',
      endTime: '',
      userName: '',
      userS: false
    }
  },
  props: {
    showApplyInput: { type: Boolean, default: true },
    maxEndDay: { type: Number, default: 9640880000000 },
    name: { type: String, default: '' },
    parkingMess: {
      type: Object,
      default: () => { }
    },
    applyData: {
      type: Object,
      default: () => { }
    },
    come: {
      type: String,
      default: ''
    }
  },
  watch: {
    maxEndDay() {
      this.endTime = ''
      this.startTime = ''
      this.date = '2020-01-01'
      this.date_m = '2050-01-01'
      this.userS = false
    }
  },
  computed: {
    curDate() {
      // 来自续签
      if (this.come == 'xuqian') {
        if (Object.keys(this.applyData).length <= 0) {
          return util.formatTime(new Date(), 19)
        }
        // 年月日格式
        let newD = this.applyData.prkParkApplyLogBeans.filter(item => {
          return item.applyStatus == 2 || item.applyStatus == 4
        })
        console.log(newD)
        let endDay = newD[0].applyEndDay;
        // 如果结束时间小于当前时间,取当前时间作为开始时间
        if (new Date(endDay.replace(/\./g, '/')).getTime() - new Date().getTime() < 0) {
          endDay = util.formatTime(new Date(), 9)
        }
        if (this.parkingMess.monthType == 2) {
          this.date = util.formatTime(new Date(new Date(endDay.replace(/\./g, '/')).getTime() + 1 * 1000), 4)
          return util.formatTime(new Date(new Date(endDay.replace(/\./g, '/')).getTime() + 1 * 1000), 19)
        } else {//年月格式
          let newD = new Date(endDay.replace(/\./g, '/'));
          newD = new Date(newD.valueOf() + 1 * 60 * 60 * 1000);
          console.log(util.formatTime(newD, 19))
          return util.formatTime(newD, 19)
        }
      } else {
        return util.formatTime(new Date(), 20)
      }
    },
    maxDate() {
      if (Object.keys(this.parkingMess).length > 0) {
        let year, month, day;
        if (this.come == 'xuqian') {
          if (Object.keys(this.applyData).length <= 0) {
            console.log("maxday1 === " + JSON.stringify(util.formatTime(new Date(), 20)) )
            return util.formatTime(new Date(), 20)
          }
          let newD = this.applyData.prkParkApplyLogBeans.filter(item => {
            return item.applyStatus == 2 || item.applyStatus == 4
          })
          let endDay = newD[0].applyEndDay;
          // 如果结束时间小于当前时间,取当前时间作为开始时间
          if (new Date(endDay.replace(/\./g, '/')).getTime() - new Date().getTime() < 0) {
            endDay = util.formatTime(new Date(), 9)
          }
          year = util.formatTime(new Date(endDay.replace(/\./g, '/')), 17).year
          month = util.formatTime(new Date(endDay.replace(/\./g, '/')), 17).month
          day = util.formatTime(new Date(endDay.replace(/\./g, '/')), 17).day
        } else {
          year = util.formatTime(new Date(), 17).year
          month = util.formatTime(new Date(), 17).month
          day = util.formatTime(new Date(), 17).day
        }
        // 非整月模式且最大起租单位是日
       // console.log("parkingMess.monthType === " + this.parkingMess.monthType + "  " + this.parkingMess.applyMaxUnit)
        if (this.parkingMess.monthType == 2 && this.parkingMess.applyMaxUnit == 1) {
          let time = new Date(year + '/' + month + '/' + day + ' 00:00:00').getTime() + (this.parkingMess.applyMaxCount - 1) * 24 * 60 * 60 * 1000;
          // 判断最大时间是否大于价格期间的最大日期
          if (time > this.maxEndDay) {
            time = this.maxEndDay
          }
          let d = util.formatTime(new Date(time), 20)
         // console.log("maxday4 === " + JSON.stringify(d) )
          return d
        } else {
          let ys = parseInt((month - 0 + this.parkingMess.applyMaxCount - 1) / 12);
          year = year + ys;
         // console.log("this.parkingMess.applyMaxCount === " + this.parkingMess.applyMaxCount)
          let m = month - 1 + this.parkingMess.applyMaxCount - ys * 12;
          month = m >= 10 ? m : '0' + m
          console.log(year, month, day)
          let newSjc = new Date(year + '/' + month + '/' + day + ' 00:00:00').getTime();
         // console.log("newSjc  ===  " + JSON.stringify(util.formatTime(new Date(newSjc), 20)))
         // console.log("this.maxEndDay  ===  " + JSON.stringify(util.formatTime(new Date(this.maxEndDay), 20)))
          if (this.come != 'xuqian' && this.parkingMess.monthType == 2) {
            newSjc = newSjc - 24 * 60 * 60 * 1000;
          }
          if (newSjc > this.maxEndDay) {
            newSjc = this.maxEndDay
          }
         // console.log("maxday3 === " + JSON.stringify(util.formatTime(new Date(newSjc), 20)) )
          return util.formatTime(new Date(this.maxEndDay), 20)  //先使用车场最多日期
        }
      } else {
       // console.log("maxday3 ===  2100/01/01 00:00"   )
        return '2100/01/01 00:00'
      }
    },
    datetimeType() {
      if (this.parkingMess.monthType == 2) {
        return 'date'
      } else {
        return 'month'
      }
    }
  },
  created() {
    this.userName = this.name
  },
  methods: {
    dateChange(val) {
      if (!this.userS) {
        return false;
      }
      if (this.timeT == '1') {
        this.startTime = val
      } else {
        this.endTime = val
      }
      this.$emit('inputChange', { val: { startTime: this.startTime, endTime: this.endTime }, type: 'time' })
    },
    nameInputFun() {
      this.$emit('inputChange', { val: this.userName, type: 'name' })
    },
    selectTime(val) {
      this.timeT = val;
      this.userS = true;
      if (this.parkingMess.monthType == 2) {
        this.$refs.datetime_date.open();
      } else {
        this.$refs.datetime_month.open();
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.apply_mess {
  margin-bottom: 14px;
  h3 {
    font-size: 30px;
    color: rgba(153, 153, 153, 1);
    line-height: 42px;
    padding: 28px 0 20px 28px;
  }
  .mess_list {
    background: #fff;
    .mess_list_item {
      padding: 0 28px;
      position: relative;
      .flex();
      height: 100px;
      align-items: center;
      .list_item_left {
        width: 164px;
        font-size: 30px;
        color: rgba(51, 51, 51, 1);
        span {
          color: #fc3f56;
        }
      }
      .list_item_right {
        flex: 1;
        height: 100px;
        .borderB();
        font-size: 30px;
        color: #333;
        box-sizing: border-box;
      }
      .list_item_right_p {
        line-height: 100px;
      }
      .last {
        .borderB(#fff);
      }
      .placeholder {
        color: #c9c9c9;
      }
      img {
        display: block;
        position: absolute;
        right: 28px;
        top: 34px;
        width: 32px;
        height: 32px;
      }
    }
  }
}
.end_time {
  .flex();
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 200px;
  img {
    display: block;
    width: 108px;
    height: 108px;
    margin-bottom: 44px;
  }
  p {
    text-align: center;
    font-size: 30px;
    color: rgba(153, 153, 153, 1);
    line-height: 42px;
  }
}
</style>
